import { useRecoilState } from "recoil";
import { profilePrefillMetadataState } from "../Atoms/Profiles/state";
import "./InlineProfilesLinkingDropdown.scss";

const placeholder = "-Select-";

/**
 * requires the following props: profiles, selectProfile, prefill
 */
const InlineProfilesLinkingDropdown = ({
  id,
  index,
  profiles,
  label,
  selected,
  selectProfile,
  prefill,
}) => {
  const [prefillMetadata, setPrefillMetadata] = useRecoilState(
    profilePrefillMetadataState
  );

  const updateMetadata = () => {
    const filtered = prefillMetadata.profiles.filter(
      (profile) => profile.type !== selected.type
    );
    filtered.push({ id: selected.id, type: selected.type });
    setPrefillMetadata((prev) => ({
      ...prev,
      profiles: filtered,
    }));
  };

  return (
    <div className="grid-row inline-profiles-linking-dd-container">
      <div className="grid-col-12 inline-profiles-linking-dd">
        <label className="inline-profiles-linking-text" htmlFor={id}>
          {label}
        </label>{" "}
        <select
          title={label}
          id={id}
          className="usa-select"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Unidentified") {
              e.preventDefault(); // this code prevents other buttons triggers use this
            }
          }}
          onChange={(e) => {
            selectProfile(e.target.value);
          }}
          value={index}
        >
          <option key={-1} value={placeholder}>
            {placeholder}
          </option>
          {profiles &&
            profiles.map((profile, index) => {
              return (
                <option key={index} value={index}>
                  {profile.name}
                </option>
              );
            })}
        </select>
        <button
          type="button"
          className="usa-button inline-profiles-linking-btn"
          disabled={selected === placeholder ? true : false}
          onClick={() => {
            updateMetadata();
            prefill();
          }}
        >
          Populate
        </button>
      </div>
    </div>
  );
};

export default InlineProfilesLinkingDropdown;
